module.exports = __webpack_public_path__ + "static/media/3.8a5d9331.JPG";